import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { useFolders } from '../../hooks/useFolders';
import { ErrorMessage } from '../ErrorMessage';

const COLORS = [
  { name: 'Azul', value: 'border-l-blue-500', bg: 'bg-blue-100' },
  { name: 'Verde', value: 'border-l-green-500', bg: 'bg-green-100' },
  { name: 'Rojo', value: 'border-l-red-500', bg: 'bg-red-100' },
  { name: 'Púrpura', value: 'border-l-purple-500', bg: 'bg-purple-100' },
  { name: 'Naranja', value: 'border-l-orange-500', bg: 'bg-orange-100' },
  { name: 'Rosa', value: 'border-l-pink-500', bg: 'bg-pink-100' },
];

export const AddFolderScreen = () => {
  const navigate = useNavigate();
  const { addFolder } = useFolders();
  const [nombre, setNombre] = useState('');
  const [colorSeleccionado, setColorSeleccionado] = useState(COLORS[0].value);
  const [error, setError] = useState(null);

  const manejarAgregar = () => {
    if (!nombre.trim()) {
      setError('El nombre de la carpeta no puede estar vacío');
      return;
    }

    addFolder(nombre.trim(), colorSeleccionado);
    navigate('/folders');
  };

  return (
    <div className="min-h-screen bg-gray-50 p-4 md:p-6">
      {/* Header */}
      <div className="flex items-center gap-3 mb-6">
        <button
          onClick={() => navigate('/folders')}
          className="p-2 hover:bg-gray-200 rounded-lg transition"
        >
          <ChevronLeft className="text-gray-700" size={24} />
        </button>
        <h1 className="text-2xl font-bold text-gray-900">Nueva Carpeta</h1>
      </div>

      {error && <ErrorMessage message={error} />}

      {/* Form */}
      <div className="bg-white rounded-lg shadow-md p-6 max-w-md">
        <div className="mb-6">
          <label className="block text-sm font-semibold text-gray-900 mb-2">
            Nombre de la carpeta
          </label>
          <input
            type="text"
            value={nombre}
            onChange={(e) => setNombre(e.target.value)}
            placeholder="ej: Mi Casa, Centro, Trabajo..."
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div className="mb-6">
          <label className="block text-sm font-semibold text-gray-900 mb-2">
            Color
          </label>
          <div className="grid grid-cols-3 gap-2">
            {COLORS.map((color) => (
              <button
                key={color.value}
                onClick={() => setColorSeleccionado(color.value)}
                className={`p-4 rounded-lg border-2 transition ${
                  colorSeleccionado === color.value
                    ? 'border-gray-900'
                    : 'border-transparent'
                } ${color.bg}`}
              >
                <span className="text-xs font-semibold text-gray-900">{color.name}</span>
              </button>
            ))}
          </div>
        </div>

        <div className="flex gap-2">
          <button
            onClick={() => navigate('/folders')}
            className="flex-1 px-4 py-2 border border-gray-300 text-gray-900 rounded-lg hover:bg-gray-50 transition font-semibold"
          >
            Cancelar
          </button>
          <button
            onClick={manejarAgregar}
            className="flex-1 px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-lg transition font-semibold"
          >
            Crear
          </button>
        </div>
      </div>
    </div>
  );
};
